/**
 * Shared TypeScript types for the Onboarding Dashboard
 * Used by both backend and frontend to ensure type consistency
 */
// Single source of truth for the auxiliary role vocabulary. The
// `AuxiliaryRole` type is derived from this array so adding a new role
// stays a one-line change and drift becomes a compile-time error in
// consumers (e.g. adminController's validAuxRoles list).
export const AUXILIARY_ROLES = [
    'mc-admin',
    'mc-viewer',
    'mc-editor',
    'insights-viewer',
    'canopus-viewer',
    'cc-viewer',
    'cc-editor',
    'brand-viewer',
    'brand-editor',
];
export const NOTIF_CONFIG_ROLES = ['admin', 'manager'];
export const DIAGNOSTIC_ROLES = ['admin', 'manager'];
// Page-level access (Mission Control, Canopus Command, Insights, Command
// Center, Brand Book, Members) lives in `constants/pageAccess.ts` —
// `PAGE_VIEW_ROLES` / `PAGE_EDIT_ROLES`. Frontend gates and backend
// `requireRole(...)` both derive from there so they cannot drift.
export const STAGE_NOTIFICATION_TYPE_LABELS = {
    offer_ready: 'Offer Ready',
    background_check_ready: 'Background Check Ready',
    interview_scheduled: 'Interview Scheduled',
    onboarding_started: 'Onboarding Started',
    candidate_completed: 'Candidate Completed',
    candidate_rejected: 'Candidate Rejected',
};
export const STAGE_NOTIFICATION_TYPE_DESCRIPTIONS = {
    offer_ready: 'Sent when a candidate enters the Offer stage and is ready to receive an offer.',
    background_check_ready: 'Sent when a candidate enters the Offer stage and a background check should be initiated.',
    interview_scheduled: 'Sent when a candidate enters the Interview stage.',
    onboarding_started: 'Sent when a candidate enters the Onboarding Docs stage.',
    candidate_completed: 'Sent when a candidate completes the hiring process.',
    candidate_rejected: 'Sent when a candidate is rejected.',
};
export const STAGE_NOTIFICATION_TYPES_BY_STAGE = {
    interview: ['interview_scheduled'],
    offer: ['offer_ready', 'background_check_ready'],
    onboarding_docs: ['onboarding_started'],
    complete: ['candidate_completed'],
    rejected: ['candidate_rejected'],
};
//# sourceMappingURL=index.js.map